import { Navigate, useLocation } from "react-router-dom";
import { ReactNode } from "react";
import { TOKEN } from "../Login/Login";
// TODO: Update the import path if necessary
// If the file does not exist, create it at src/utils/constants.ts with the following content:
// export const TOKEN = "your_token_key";
interface PrivateRouteProps {
  children: ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  // Bypass authentication - allow access without login
  return children;
};

export default PrivateRoute;
